import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';

export const ThemeToggle = ({ compact = false }) => {
  const { theme, resolvedTheme, setTheme } = useTheme();

  const Icon = resolvedTheme === 'dark' ? Moon : Sun;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Changer le thème"
          className={`rounded-full text-worldplate-muted hover:text-worldplate-text hover:bg-worldplate-subtle ${compact ? 'h-9 w-9' : 'h-10 w-10'}`}
          data-testid="theme-toggle-btn"
        >
          <Icon className="w-[1.15rem] h-[1.15rem] transition-transform" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem
          onClick={() => setTheme('light')}
          className={`gap-2 cursor-pointer ${theme === 'light' ? 'text-worldplate-primary font-medium' : ''}`}
          data-testid="theme-light"
        >
          <Sun className="w-4 h-4" /> Clair
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setTheme('dark')}
          className={`gap-2 cursor-pointer ${theme === 'dark' ? 'text-worldplate-primary font-medium' : ''}`}
          data-testid="theme-dark"
        >
          <Moon className="w-4 h-4" /> Sombre
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setTheme('system')}
          className={`gap-2 cursor-pointer ${theme === 'system' ? 'text-worldplate-primary font-medium' : ''}`}
          data-testid="theme-system"
        >
          <Monitor className="w-4 h-4" /> Système
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ThemeToggle;
